var Backbone = require('backbone')
  , _ = require('underscore')
  , tmpl = require('./tmpl.handlebars')
  , successResultTmpl = require('./successResult.handlebars')
  , enableDialog = require('ui/enableDialog')
  , formUtils = require('@173js/ui/form')
  , ued = window.ued || {}
  , ValidateForm = require('widgets/ValidateForm')

var View = Backbone.View.extend({
  events: {
    'submit form': 'formSubmitted'
  , 'keyup textarea[name="content"]': 'handleContentChanged'
  }
, initialize: function(options) {
    options = options || {}
  }
, formSubmitted: function(e) {
    e.preventDefault()
  }
, renderFieldErrors: function(fieldErrors) {
    var errorBlock = this.$('.errors-block')
    if (!fieldErrors || !fieldErrors.length) {
      errorBlock.hide()
      return
    }

    errorBlock.empty()

    _.each(fieldErrors, function(x) {
      if (!x.message) { return }
      errorBlock.append('<li>' + x.message + '</li>')
    })

    // force captcha refresh
    this.$('.xcaptcha_img_change').click()

    errorBlock.show()
  }
, submitFormFromSudoku: function(captchaCode, error) {
    var dict = formUtils.toDict(this.form)
      , EMPTY_ERRORS = []

    if (!this.validateForm.validate()) {
      this.renderFieldErrors(this.validateForm.fieldErrors)
      return
    }

    formUtils.readonlyForm(this.form)

    this.renderFieldErrors(EMPTY_ERRORS)

    this.ajaxSubmitForm(
      _.extend(
          { id: ued.gameCode, code: captchaCode }
        , dict
      )
    )
    .done(_.bind(function(resp) {
      var SUCCESS = 1
      if (resp.status === SUCCESS) {
        this.showSuccessResult()
        return
      }

      this.renderFieldErrors([{ message: resp.msg }])
    }, this))
    .fail(_.bind(function() {
      this.renderFieldErrors([{ message: '网络发生了错误' }])
    }, this))
    .always(_.bind(function() {
      formUtils.resumeForm(this.form)
    }, this))
  }
, showSuccessResult: function() {
    this.$el.html(successResultTmpl())
  }
, ajaxSubmitForm: function(data) {
    return $.ajax({
      type: 'POST'
    , url: '/legacy-cherish.html'
    , data: data
    , dataType:'json'
    })
  }
, handleContentChanged: function(e) {
    var textarea = $(e.currentTarget)
      , content = $.trim(textarea.val())
      , contentLength = content.length

    this.renderContentRemainLengthTips(contentLength)
  }
, renderContentRemainLengthTips: function(contentLength) {
    var MAX_CONTENT_LENGTH = 50
      , remainLength = MAX_CONTENT_LENGTH - contentLength
      , hasOverflowLength = remainLength < 0
      , tipsContainer = this.$('.textarea-words-num')

    tipsContainer.css({
      'color': hasOverflowLength ? 'red': 'inherit'
    })

    tipsContainer.html(
        (hasOverflowLength
          ? '已经超出了'
          : '还可以输入')
      +'<b>' + Math.abs(remainLength) + '</b>个字'
    )
  }
, render: function() {
    var EMPTY_CONTENT_LENGTH = 0

    this.$el.html(tmpl())
    this.form = this.$('form')

    this.validateForm = new ValidateForm({
      form: this.form
    })

    this.renderContentRemainLengthTips(EMPTY_CONTENT_LENGTH)

    this.$('#sudoku').sudoku({
      'ajaxValidata': false
    , 'callback': _.bind(this.submitFormFromSudoku, this)
    })

    return this
  }
})

module.exports = enableDialog(View, { title: '怀念' })
